/**
 * Mouseflow loader — session replay & heatmaps.
 * Consent-gated (Analytics cookie category) and production-only.
 */

const PRODUCTION_HOSTS = new Set([
  "vitolier.com",
  "www.vitolier.com",
  "vitolier.app",
  "www.vitolier.app",
  "vitolier.lovable.app",
]);

const MOUSEFLOW_PROJECT_ID = "4395edc3-ce0a-4612-9031-9eb7fa747d75";

declare global {
  interface Window {
    _mfq?: unknown[];
  }
}

let loaded = false;

function isProductionHost(): boolean {
  if (typeof window === "undefined") return false;
  return PRODUCTION_HOSTS.has(window.location.hostname);
}

export function loadMouseflow(): void {
  if (loaded) return;
  if (typeof window === "undefined" || typeof document === "undefined") return;
  if (!isProductionHost()) return;

  loaded = true;
  window._mfq = window._mfq || [];

  const mf = document.createElement("script");
  mf.type = "text/javascript";
  mf.defer = true;
  mf.src = `//cdn.mouseflow.com/projects/${MOUSEFLOW_PROJECT_ID}.js`;
  document.getElementsByTagName("head")[0]?.appendChild(mf);
}

export function trackMouseflowPageView(path: string): void {
  if (!loaded) return;
  if (typeof window === "undefined") return;
  window._mfq = window._mfq || [];
  window._mfq.push(["newPageView", path]);
}
